// Section 17 and 18: Food ration policy. Equal shares / Minimum floor then priority / Priority
// only / Manual; default floor then priority. The preview names who eats first if food runs short.
// Default: config.policies.defaults.foodRation.
import type { Config } from '../../config';
import { noChangeCost, noProblem } from '../../core/content-helpers';
import { peopleSorted } from '../../core/queries';
import { definePolicy, noModifiers } from '../../core/registry';
import type { ReadContext } from '../../core/types';

/** The first listed group with members, as a label and a head count. */
function firstGroup(ctx: ReadContext): { group: string; count: number } | null {
  for (const id of ctx.state.policies.foodPriority) {
    const n = ctx.registry.priorityGroups[id].members(ctx).length;
    if (n > 0) return { group: ctx.registry.priorityGroups[id].label, count: n };
  }
  return null;
}

export function foodRation(config: Config) {
  return definePolicy({
    id: 'foodRation',
    label: 'Food ration',
    section: 'S18',
    group: 'rations',
    options: ['equal', 'floor-priority', 'priority', 'manual'],
    default: config.policies.defaults.foodRation,
    modifierTargets: [],
    modifiers: noModifiers,
    changeCost: noChangeCost,
    affects(ctx, option) {
      const people = peopleSorted(ctx.state).length;
      const first = firstGroup(ctx);
      switch (option) {
        case 'equal':
          return [{ key: 'policy.foodRation.equal', params: { people } }];
        case 'floor-priority':
          return [
            {
              key: 'policy.foodRation.floor-priority',
              params: {
                floor: Math.round(ctx.state.policies.foodFloor * 100),
                group: first?.group ?? '',
                count: first?.count ?? 0,
              },
            },
          ];
        case 'priority':
          return [
            {
              key: 'policy.foodRation.priority',
              params: { group: first?.group ?? '', count: first?.count ?? 0 },
            },
          ];
        case 'manual':
          return [{ key: 'policy.foodRation.manual', params: { people } }];
      }
    },
    validate: noProblem,
  });
}
